import React from 'react';
import useReviewsContainerData from './useReviewsContainerData';

interface IReviewsContainerProps {
  url?: string;
  limit?: number;
  hideLoader?: boolean;
  externalProps?: any;
  component?: React.ComponentType<React.PropsWithChildren<any>>;
}

const ReviewsContainer: React.FC<React.PropsWithChildren<IReviewsContainerProps>> = ({
  url,
  component: Component,
  limit,
  externalProps = {},
  hideLoader = false,
}) => {
  const {
    totalCount,
    summary,
    averageScore,
    reviewItems,
    pagination,
    handleFetchNextSetOfReviews,
  } = useReviewsContainerData({ apiUrl: url, limit, hideLoader });
  return (
    (!!Component && averageScore && (
      <Component
        totalCount={totalCount}
        summary={summary}
        averageScore={averageScore}
        reviewItems={reviewItems}
        pagination={pagination}
        onNext={handleFetchNextSetOfReviews}
        {...externalProps}
      />
    )) ||
    null
  );
};
export default ReviewsContainer;
